export const getFormattedCurrency = (amount: number, currency?: string) => {
  const incomingAmount = amount || 0;

  return incomingAmount.toLocaleString("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];

export const formatNumber = (number: number, currency?: string) => {
  // what tier? (determines SI symbol)
  var tier = (Math.log10(Math.abs(number)) / 3) | 0;

  // if zero, we don't need a suffix
  if (tier < 2) return number;

  // get suffix and determine scale
  var suffix = SI_SYMBOL[tier];
  var scale = Math.pow(10, tier * 3);

  // scale the number
  var scaled = number / scale;

  if (currency === "none") return scaled.toFixed(0) + suffix;
  
  // format number and add suffix
  return (
    scaled.toLocaleString("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }) + suffix
  );
};
